

























































































import Vue from 'vue'
import ArrowInfo from './ArrowInfo.vue'
import * as d3 from 'd3'
import { getLongHeaderName, getFrameName } from '../../data/QuicNames'
import { svg, interpolateBrBG } from 'd3';
export default {
    name: "SequenceArrow",
    props: ['packet_conn', 'send_coord', 'send_time', 'receive_coord', 'receive_time'],
    data() {
        return {
            framename_translate: 100
        }
    },
    computed: {
        clientsend(){
            return this.$store.state.sequencesettings.isPacketClientSend(this.packet_conn.headerinfo.dest_connection_id)
        },
        headername() {
            if (parseInt(this.packet_conn.headerinfo.header_form) === 0) return '1-RTT protect'
            else
                return getLongHeaderName(parseInt(this.packet_conn.headerinfo.long_packet_type))
        }, 
        y_receive(){
            if( this.receive_time <= -1 ){
                // packet is lost, slightly slanted half-arrow
                return 20; 
            }
            else{
                if (this.receive_coord > -1)
                    return this.receive_coord - this.send_coord
                else{
                    console.error("SequenceArrow: had no receive_coord, cannot render!", this);
                    return 0
                }
            }
        },
        packetlost(){
            return this.receive_time <= -1;
        },
        receivedelta(){
            if (this.receive_time > -1)
                return this.receive_time.toFixed(2)
            else
                return 'xx.xx';
        },
        angle(){
            let opp = 700
            let adj = this.y_receive

            let angle = Math.atan(opp/adj) * 180 / Math.PI
            return 90 - angle
        },
        centerpoint_text(){
            // see ArrowInfo for how the text is translated. These values are based on x-translates of 200 and 450
            // this is basically a LERP of the y-value across the line at the correct percentage 
            if (this.clientsend)
                return this.y_receive * 0.0714285; // starts at 200, which is 50 more than the start of 150. total x-range is 850 - 150 = 700. 50/700 = 0.0714285
            else
                return this.y_receive * 0.5714286;// starts at 450, 300 more than the start of 150:  400/700 = 0.5714286
        },
        showtimestamps(){
            return this.$store.state.sequencesettings.getSeqFilter('timestamps')
        },
    },
    methods: {
        frameName(frametype: string){
            return getFrameName(parseInt(frametype))
        },
        framebgcolor(frametype: string){
            return this.$store.state.framecolortables.getFrameColour([frametype])
        },
        putOnForeground(ev: any){
            let el: HTMLElement;
            let svg: HTMLElement;
            for (let i = 0; i < ev.path.length; i++) {
                if (i > 0 && ev.path[i].id === 'sequencediagram'){
                    el = ev.path[i - 1]
                    svg = ev.path[i]
                    break;
                }
            }
            this.addHighlightBox(svg, el)
            el.remove()
            svg.appendChild(el)
        },
        addHighlightBox(svg: HTMLElement, el: HTMLElement){
            let box = document.getElementById('arrow-background-box')
            if (box)
                box.remove()

            let svgd3 = d3.select(el)
            let x = parseFloat(el.children[0].getAttribute('x1')) + 2
            let y = 0

            let width = parseFloat(el.children[0].getAttribute('x2')) - x - 2
            //get highest y coord for drawing bounding box
            let height = parseFloat(el.children[0].getAttribute('y2')) > 0 ? parseFloat(el.children[0].getAttribute('y2')) : parseFloat(el.children[0].getAttribute('y1'))

            if (height === 0) {
                y = -20
                height = 20
            }

            svgd3.append('rect').attr('id', 'arrow-background-box').attr('x', x).attr('y', y)
                .attr('width', width).attr('height', height).attr('fill', 'white').on('dblclick', this.removeHighlightBox)

            //position all elements of the packet in front of white box
            for (let i = 0; i < el.children.length - 1; i++) {
                let child = el.children[0]
                child.remove()
                el.appendChild(child)
                
            }
        },
        removeHighlightBox(){
            let box = document.getElementById('arrow-background-box')
            if (box)
                box.remove()
        }
    },
    components: {
        ArrowInfo
    }
}
